export default __webpack_public_path__ + "static/media/rgp_pvh_nca_west_kazakh.06139c6c.png";